<template>
    <v-col cols="12" class="">
        <v-row>
            <v-col cols="12" align="center" class="custom-card">
                <v-card
                    class="px-md-2 px-lg-4 py-0 py-lg-4"
                    elevation="0"
                >
                <v-col cols="12" align="start" class="px-0 pt-lg-0 headers-text">
                    <p class="mb-0">
                        <strong>{{ $t('profile.abilities') }}</strong>
                    </p>
                    <small class="mb-0">{{ $t('profile.check_your_progress') }}</small>
                </v-col>
                    <v-row justify="end" align="center" class="ma-0">
                        <v-col cols="5" md="2" class="ma-0 pa-0">
                            <v-select
                                class="select-no-margin"
                                v-model="rank"
                                :items="rankOptions"
                                :disabled="!progressReady"
                                @change="changeRank"
                            ></v-select>
                        </v-col>
                        <v-col 
                            cols="12"
                            class="pa-0"
                            v-if="showTabs"
                            >
                            <v-tabs
                                v-model="tabs"
                                class="tabs-graphics"
                                color="#7764CA"
                                grow
                                >
                                <v-tab>
                                    LOC 
                                </v-tab>
                                <v-tab>
                                    IN 
                                </v-tab>
                                <v-tab>
                                    RV
                                </v-tab>
                            </v-tabs>
                        </v-col>

                    </v-row>

                    <!-- desktop view -->
                    <v-row v-if="!showTabs" class="progress-wrap">
                        <v-col cols="12" md="4">
                            <div class="progress-item">
                                <p class="progress-title">{{ $t('profile.abilityOne.title') }}</p>
                                <div class="progress-graphic">
                                    <vue-ellipse-progress
                                    :loading="!progressReady"
                                    :progress="selectedProgress.localizar"
                                    :size="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?130:200"
                                    :legend="true"
                                    emptyColor="#E7EAEE"
                                    :color="selectedProgress.localizar <= 40 ? '#E86B59' : selectedProgress.localizar > 40 && selectedProgress.localizar <= 80 ? '#E3B716' : '#3FB16D'"
                                    thickness="10"
                                    emptyThickness="10"
                                    >
                                        <span slot="legend-value">%</span>
                                    </vue-ellipse-progress>
                                    
                                    <span class="progress-emoji">
                                        <v-img
                                            :src="getLevelIcon(selectedProgress.localizar)"
                                            height="48"
                                            width="48"
                                        ></v-img>
                                    </span>

                                </div>
                                <!-- <p class="progress-description" v-html="$t('profile.abilityOne.desc', [ getLevel(selectedProgress.localizar) ])"></p> -->
                                <p class="progress-description" v-if="selectedProgress.localizar > 80" v-html="$t('profile.abilityLocalizar.green')"></p>
                                <p class="progress-description" v-if="selectedProgress.localizar > 40 && selectedProgress.localizar <= 80" v-html="$t('profile.abilityLocalizar.yellow')"></p>
                                <p class="progress-description" v-if="selectedProgress.localizar <= 40" v-html="$t('profile.abilityLocalizar.red')"></p>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4" class="">
                            <div class="progress-item fill-height">
                                <p class="progress-title">{{ $t('profile.abilityTwo.title') }}</p>
                                <div class="progress-graphic">
                                    <vue-ellipse-progress
                                    :loading="!progressReady"
                                    :progress="selectedProgress.integrar"
                                    :size="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?130:200"
                                    :legend="true"
                                    emptyColor="#E7EAEE"
                                    :color="selectedProgress.integrar <= 40 ? '#E86B59' : selectedProgress.integrar > 40 && selectedProgress.integrar <= 80 ? '#E3B716' : '#3FB16D'"
                                    thickness="10"
                                    emptyThickness="10"
                                    >
                                        <span slot="legend-value">%</span>
                                    </vue-ellipse-progress>
                                    
                                    <span class="progress-emoji">
                                        <v-img
                                            :src="getLevelIcon(selectedProgress.integrar)"
                                            height="48"
                                            width="48"
                                        ></v-img>
                                    </span>
                                    
                                </div>
                                <!-- <p class="progress-description" v-html="$t('profile.abilityTwo.desc', [ getLevel(selectedProgress.integrar) ])"></p> -->
                                <p class="progress-description" v-if="selectedProgress.integrar > 80" v-html="$t('profile.abilityIntegrar.green')"></p>
                                <p class="progress-description" v-if="selectedProgress.integrar > 40 && selectedProgress.integrar <= 80" v-html="$t('profile.abilityIntegrar.yellow')"></p>
                                <p class="progress-description" v-if="selectedProgress.integrar <= 40" v-html="$t('profile.abilityIntegrar.red')"></p>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4" class="">
                            <div class="progress-item fill-height">
                                <p class="progress-title">{{ $t('profile.abilityThree.title') }}</p>
                                <div class="progress-graphic">
                                    <vue-ellipse-progress
                                    :loading="!progressReady"
                                    :progress="selectedProgress.reflexionar"
                                    :size="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?130:200"
                                    :legend="true"
                                    emptyColor="#E7EAEE"
                                    :color="selectedProgress.reflexionar <= 40 ? '#E86B59' : selectedProgress.reflexionar > 40 && selectedProgress.reflexionar <= 80 ? '#E3B716' : '#3FB16D'"
                                    thickness="10"
                                    emptyThickness="10"
                                    >
                                        <span slot="legend-value">%</span>
                                    </vue-ellipse-progress>
                                    
                                    <span class="progress-emoji">
                                        <v-img
                                            :src="getLevelIcon(selectedProgress.reflexionar)"
                                            height="48"
                                            width="48"
                                        ></v-img>
                                    </span>
                                    
                                </div>
                                <!-- <p class="progress-description" v-html="$t('profile.abilityThree.desc', [ getLevel(selectedProgress.reflexionar) ])"></p> -->
                                <p class="progress-description" v-if="selectedProgress.reflexionar > 80" v-html="$t('profile.abilityReflexionar.green')"></p>
                                <p class="progress-description" v-if="selectedProgress.reflexionar > 40 && selectedProgress.reflexionar <= 80" v-html="$t('profile.abilityReflexionar.yellow')"></p>
                                <p class="progress-description" v-if="selectedProgress.reflexionar <= 40" v-html="$t('profile.abilityReflexionar.red')"></p>
                            </div>
                        </v-col>
                    </v-row>
                    <!-- desktop view -->

                    <v-row v-if="showTabs" align="center" class="mt-5">
                        <v-tabs-items v-model="tabs">
                            <v-tab-item> 
                                <v-row class="ma-0">
                                    <v-col>
                                        <p class="progress-title">{{ $t('profile.abilityOne.title') }}</p>
                                        <div class="progress-graphic">
                                            <vue-ellipse-progress
                                                :loading="!progressReady"
                                                :progress="selectedProgress.localizar"
                                                :size="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?220:220"
                                                :legend="true"
                                                emptyColor="#E7EAEE"
                                                :color="selectedProgress.localizar <= 40 ? '#E86B59' : selectedProgress.localizar > 40 && selectedProgress.localizar <= 80 ? '#E3B716' : '#3FB16D'"
                                                thickness="10"
                                                emptyThickness="10"
                                                >
                                                <span slot="legend-value">%</span>
                                            </vue-ellipse-progress>
                                            <span class="progress-emoji">
                                                <v-img
                                                    :src="getLevelIcon(selectedProgress.localizar)"
                                                    height="48"
                                                    width="48"
                                                ></v-img>
                                            </span>
                                        </div>
                                        <!-- <p class="progress-description" v-html="$t('profile.abilityOne.desc', [ getLevel(selectedProgress.localizar) ])"></p> -->
                                        <p class="progress-description" v-if="selectedProgress.localizar > 80" v-html="$t('profile.abilityLocalizar.green')"></p>
                                        <p class="progress-description" v-if="selectedProgress.localizar > 40 && selectedProgress.localizar <= 80" v-html="$t('profile.abilityLocalizar.yellow')"></p>
                                        <p class="progress-description" v-if="selectedProgress.localizar <= 40" v-html="$t('profile.abilityLocalizar.red')"></p>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item>
                                <v-row class="ma-0">
                                    <v-col>
                                        <p class="progress-title">{{ $t('profile.abilityTwo.title') }}</p>
                                        <div class="progress-graphic">
                                            <vue-ellipse-progress
                                            :loading="!progressReady"
                                            :progress="selectedProgress.integrar"
                                            :size="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?220:220"
                                            :legend="true"
                                            emptyColor="#E7EAEE"
                                            :color="selectedProgress.integrar <= 40 ? '#E86B59' : selectedProgress.integrar > 40 && selectedProgress.integrar <= 80 ? '#E3B716' : '#3FB16D'"
                                            thickness="10"
                                            emptyThickness="10"
                                            >
                                                <span slot="legend-value">%</span>
                                            </vue-ellipse-progress>
                                            
                                            <span class="progress-emoji">
                                                <v-img
                                                    :src="getLevelIcon(selectedProgress.integrar)"
                                                    height="48"
                                                    width="48"
                                                ></v-img>
                                            </span>
                                            
                                        </div>
                                        <!-- <p class="progress-description" v-html="$t('profile.abilityTwo.desc', [ getLevel(selectedProgress.integrar) ])"></p> -->
                                        <p class="progress-description" v-if="selectedProgress.integrar > 80" v-html="$t('profile.abilityIntegrar.green')"></p>
                                        <p class="progress-description" v-if="selectedProgress.integrar > 40 && selectedProgress.integrar <= 80" v-html="$t('profile.abilityIntegrar.yellow')"></p>
                                        <p class="progress-description" v-if="selectedProgress.integrar <= 40" v-html="$t('profile.abilityIntegrar.red')"></p>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item>
                                <v-row class="ma-0">
                                    <v-col>
                                        <p class="progress-title">{{ $t('profile.abilityThree.title') }}</p>
                                        <div class="progress-graphic">
                                            <vue-ellipse-progress
                                            :loading="!progressReady"
                                            :progress="selectedProgress.reflexionar"
                                            :size="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?220:220"
                                            :legend="true"
                                            emptyColor="#E7EAEE"
                                            :color="selectedProgress.reflexionar <= 40 ? '#E86B59' : selectedProgress.reflexionar > 40 && selectedProgress.reflexionar <= 80 ? '#E3B716' : '#3FB16D'"
                                            thickness="10"
                                            emptyThickness="10"
                                            >
                                                <span slot="legend-value">%</span>
                                            </vue-ellipse-progress>
                                            
                                            <span class="progress-emoji">
                                                <v-img
                                                    :src="getLevelIcon(selectedProgress.reflexionar)"
                                                    height="48"
                                                    width="48"
                                                ></v-img>
                                            </span>
                                            
                                        </div>
                                        <!-- <p class="progress-description" v-html="$t('profile.abilityThree.desc', [ getLevel(selectedProgress.reflexionar) ])"></p> -->
                                        <p class="progress-description" v-if="selectedProgress.reflexionar > 80" v-html="$t('profile.abilityReflexionar.green')"></p>
                                        <p class="progress-description" v-if="selectedProgress.reflexionar > 40 && selectedProgress.reflexionar <= 80" v-html="$t('profile.abilityReflexionar.yellow')"></p>
                                        <p class="progress-description" v-if="selectedProgress.reflexionar <= 40" v-html="$t('profile.abilityReflexionar.red')"></p>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>

export default {
    props: {
        progress: {
            type: Array
        }
    },
    computed: {
        // height() {
        //     if (this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm) {
        //         return 750
        //     }
        //     if (this.$vuetify.breakpoint.md) {
        //         return 730
        //     }
        //     if (this.$vuetify.breakpoint.xl) {
        //         return 400
        //     }
        //     return 430
        // },
    },
    data() {
        return {
            gradientOne: {
                radial: false,
                colors: [
                    {
                        color: '#FF707D',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#FF051B',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            },
            gradientTwo: {
                radial: false,
                colors: [
                    {
                        color: '#A58DFF',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#6F55D0',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            },
            gradientThree: {
                radial: false,
                colors: [
                    {
                        color: '#57AFFF',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#1785E8',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            },
            progressReady: false,
            rank: '4',
            selectedProgress: {
                index: 0,
                localizar: 0,
                reflexionar: 0,
                integrar: 0
            },
            showTabs: false,
            rankOptions: [
                { text: this.$t('profile.global_progress_rank[0]'), value: '4' },
                { text: this.$t('profile.global_progress_rank[1]'), value: '8' },
                { text: this.$t('profile.global_progress_rank[2]'), value: '12' },
            ],
            tabs: null,
        }
    },
    mounted() {
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        changeRank () {
            if (this.rank === '12') {
                // eslint-disable-next-line prefer-destructuring
                this.selectedProgress = this.progress[2]
            }
            if (this.rank === '8') {
                // eslint-disable-next-line prefer-destructuring
                this.selectedProgress = this.progress[1]
            }
            if (this.rank === '4') {
                // eslint-disable-next-line prefer-destructuring
                this.selectedProgress = this.progress[0]
            }
            this.progressReady = true
        },
        getLevel (progress) {
            if (progress <= 40) {
                return this.$t('profile.abilityLevels[0]')
            }
            if (progress > 40 && progress <= 80) {
                return this.$t('profile.abilityLevels[1]')
            }
            return this.$t('profile.abilityLevels[2]')
        },
        getLevelIcon (progress) {
            if (progress == 0) {
                const iconProgress = require('@/assets/img/icons/user/icon-progress-empty.png')
                return iconProgress
            }
            if (progress > 0 && progress <= 40) {
                const iconProgress = require('@/assets/img/icons/user/icon-progress-red.png')
                return iconProgress
            }
            if (progress > 40 && progress <= 80) {
                const iconProgress = require('@/assets/img/icons/user/icon-progress-yellow.png')
                return iconProgress
            }
            if (progress > 80) {
                const iconProgress = require('@/assets/img/icons/user/icon-progress-green.png')
                return iconProgress
            }
        },
        checkScreenSize() {
            if (window.innerWidth < 960) { 
                this.showTabs = true;
            } else {
                this.showTabs = false;
            }
        },
    },
    watch: {
        progress() {
            this.changeRank()
        }
    }
}
</script>
<style lang="scss" scoped>
.ability-3 {
    margin-top: -15px;
}
.color-text {
    color: #4A3216;
}
.v-card {
    border-radius: 20px;
}
.v-btn-toggle>.v-btn.v-btn--active {
    border-bottom: 5px solid #FF6F3A;
    color: #4A3216;
    opacity: 1;
}
.v-btn:before {
    background-color: white;
}
.v-btn {
    text-transform: none;
}

.progress{
    &-wrap{
    
    }
    &-item{
        background: #F7F8F9;
        border-radius: 12px;
        padding: 2em;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    &-title{
        font-weight: 600;
        font-size: 1.13em;
        line-height: 1.2em;
        color: #323A46;
    }
    &-description{
        color: #323A46;
        font-weight: 400;
        font-size: .89em;
        margin-bottom: 0;
        margin-top: 16px;
        text-align: left;
    }
    &-graphic{
        position: relative;
    }
    &-emoji{
        top: 18%;
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
        @media screen and (min-width: 940px){
            top: 15%;
        }
    }
}
::v-deep .ep-legend--value{
    font-size: 1.4em;
    font-weight: 700;
}
::v-deep .tabs-graphics{
    .v-slide-group__prev.v-slide-group__prev--disabled,
    .v-slide-group__next.v-slide-group__next--disabled{
        display: none!important;
    }
    .v-tabs-slider-wrapper{
        box-shadow: 0px 0px 2px 0px #7764CA80;
        height: 3px!important;    
    }
    .v-tab--active{
        color: #323A46!important;
        &:before{
            content: '';
            opacity: 0!important;
        }
    }
}
::v-deep .select-no-margin{
    .v-select__selections{
        flex-direction: row-reverse;
    }
    .v-input__slot{
        margin-bottom: 0;
        &:before{
            border: 0;
        }
    }
}
.v-item-group{
    width: 100%;
}
</style>